import { OrderStatusModel } from '@merchant-clients/order';

export type OrderFilterInputStatusType = OrderStatusModel | 'ALL';

export interface OrderFilterInput {
  /** `['ALL']` in the form represents "all places"; `undefined` after submit means "all places". */
  placeIds: string[] | undefined;
  period: PeriodModel;
  status: OrderFilterInputStatusType[];
  preOrder: string;
}

export const allowedPeriodTypeValues = [
  'TODAY',
  'THIS_WEEK',
  'THIS_MONTH',
] as const;

export type PeriodModel = (typeof allowedPeriodTypeValues)[number];
